const mixin = {
  methods: {
    $errors($v) {
      const errs = [];
      if ($v.$dirty) {
        if (
          $v.required === false ||
          $v.requiredIf === false ||
          $v.notEmpty === false
        ) {
          errs.push(this.$t('errors.required'));
        }
        if ($v.email === false) {
          errs.push(this.$t('errors.email'));
        }
        if ($v.minLength === false) {
          errs.push(this.$t('errors.minLength', [$v.$params.minLength.min]));
        }
        if ($v.maxLength === false) {
          errs.push(this.$t('errors.maxLength', [$v.$params.maxLength.max]));
        }
        if ($v.integer === false) {
          errs.push(this.$t('errors.integer'));
        }
        if ($v.decimal === false) {
          errs.push(this.$t('errors.decimal'));
        }
        if ($v.minValue === false) {
          errs.push(this.$t('errors.minValue', [$v.$params.minValue.min]));
        }
        if ($v.sameAsPassword === false) {
          errs.push(this.$t('utilisateur.password.missmatch'));
        }
        if ($v.minDate === false) {
          errs.push(this.$t('errors.minDate', [$v.$params.minDate.min]));
        }
        if ($v.minDateOrEqual === false) {
          errs.push(
            this.$t('errors.minDateOrEqual', [$v.$params.minDateOrEqual.min]),
          );
        }
        if ($v.maxDateOrEqual === false) {
          errs.push(
            this.$t('errors.maxDateOrEqual', [$v.$params.maxDateOrEqual.max]),
          );
        }
        if ($v.startLessThanEnd === false) {
          errs.push(
            this.$t('errors.startLessThanEnd', [
              $v.$params.startLessThanEnd.fin,
            ]),
          );
        }
        if ($v.minHeure === false) {
          errs.push(this.$t('errors.minHeure', [$v.$params.minHeure.min]));
        }
        if ($v.maxHeure === false) {
          errs.push(this.$t('errors.maxHeure', [$v.$params.maxHeure.max]));
        }
        if ($v.sirenOuSiret === false) {
          errs.push(this.$t('errors.sirenOuSiret'));
        }
        if ($v.siren === false) {
          errs.push(this.$t('errors.siren'));
        }
        if ($v.siret === false) {
          errs.push(this.$t('errors.siret'));
        }
      }
      return errs;
    },
  },
};

export default {
  install(Vue) {
    Vue.mixin(mixin);
  },
};
